module.exports = {
  key: 'add',
  icon: 'md-add',
  name: '添加任务',
  do({tasks}, newTasks) {
    if (!newTasks) {
      throw new Error(`add/do:unexpected null params`);
    }
    if (Array.isArray(newTasks) == false) {
      newTasks = [newTasks];
    }

    newTasks.forEach((t)=>{
      t.id = (new Date()).getTime();
    });

    tasks.splice(tasks.length-1, 0, newTasks);
    return newTasks.map((v)=>v.id);
  },
  undo: 'remove',
};
